import _ from "underscore";

export const MILLISECONDS_IN_DAY = 86400000;
export const METAL_TIERS = {
  bronze: "Bronze",
  silver: "Silver",
  gold: "Gold",
  platinum: "Platinum",
};
export const NETWORK_TYPES = {
  EPO: "EPO",
  HMO: "HMO",
  HMP: "HMP",
  Indemnity: "Indemnity",
  POS: "POS",
  PPO: "PPO",
};
export const ALL_ROLES = Object.freeze({
  full_time: "Full-Time",
  part_time: "Part-Time",
  hourly: "Hourly",
  managers: "Managers",
  owners: "Owners",
  owner: "Owner",
  spouse: "Spouse",
  child: "Child",
  domestic_partner: "Domestic Partner",
});
export const TIERED_CONTRIBUTION_ROLES = Object.freeze({
  full_time: "Full-Time or Salaried Employees",
  part_time: "Part-Time Employees",
  hourly: "Hourly Employees",
  managers: "Managers",
  owners: "Owners",
});
export const TIERED_CONTRIBUTIONS_SORTING_ORDER = Object.freeze(["full_time", "part_time", "hourly", "managers", "owners"]);
export const MIN_TIERED_CONTRIBUTIONS = 2;
export const SINGLE_PLAN_CONTRIBUTION_TYPES = Object.freeze({
  percentage: "% of total premium",
  fixed: "Flat dollar amount",
});
export const MULTIPLE_PLAN_CONTRIBUTION_TYPES = Object.freeze({
  percentage: "% of total premium",
  fixed: "Flat dollar amount",
  percent_of_base_plan: "% of the least expensive plan",
});

/** @deprecated Do not use CONTRIBUTION_TYPES.[value] as keys in a key-value pair */
export const CONTRIBUTION_TYPES = Object.freeze({
  percentage: "A percentage",
  fixed: "A flat dollar amount",
  percent_of_base_plan: "A percentage of the least expensive plan",
});
export const CONTRIBUTION_METHODS = Object.freeze({
  tiered: "Tiered",
  nonTiered: "Non Tiered",
});

// BOR Constants
// MEDICAL_INSURANCE_COMPANIES
export const SUPPORTED_CARRIERS = [
  ["aetna", "Aetna"],
  ["aflac", "AFLAC"],
  ["allways_health", "AllWays Health Partners"],
  ["amerihealth", "AmeriHealth"],
  ["anthem", "Anthem"],
  ["asuris", "Asuris Northwest Health"],
  ["avmed", "AvMed"],
  ["allstate", "Allstate"],
  ["bcbs", "Blue Cross Blue Shield"],
  ["blue_shield", "Blue Shield"],
  ["blue_choice", "BlueChoice"],
  ["cal_choice", "Cal Choice"],
  ["capital_bluecross", "Capital BlueCross"],
  ["careconnect", "CareConnect"],
  ["carefirst_bcbs", "CareFirst BCBS"],
  ["choice_builder", "Choice Builder"],
  ["cigna", "Cigna"],
  ["cigna_oscar", "Cigna + Oscar"],
  ["delta_dental", "Delta Dental"],
  ["dental_care_plus", "Dental Care Plus"],
  ["dental_select", "Dental Select"],
  ["emblem_health", "EmblemHealth"],
  ["empire_bcbs", "Empire BCBS"],
  ["excellus_bcbs", "Excellus BCBS"],
  ["fallon", "Fallon Health"],
  ["florida_blue", "Florida Blue"],
  ["geisinger", "Geisinger Health Plan"],
  ["group_health", "Group Health"],
  ["guardian", "Guardian"],
  ["harvard_pilgrim", "Harvard Pilgrim"],
  ["health_net", "Health Net"],
  ["health_new_england", "Health New England"],
  ["health_republic", "Health Republic"],
  ["health_first", "Health First"],
  ["health_partners", "Health Partners"],
  ["healthy_ct", "Healthy CT"],
  ["highmark", "Highmark"],
  ["horizon_bcbs", "Horizon BCBS"],
  ["humana", "Humana"],
  ["independence_bc", "Independence Blue Cross"],
  ["kaiser", "Kaiser"],
  ["medical_mutual", "Medical Mutual"],
  ["memorial_hermann", "Memorial Hermann Health Solutions"],
  ["oscar", "Oscar"],
  ["oxford", "Oxford"],
  ["premera", "Premera"],
  ["priority_health", "Priority Health"],
  ["providence", "Providence"],
  ["regence", "Regence"],
  ["SBMA", "SBMA"],
  ["selecthealth", "SelectHealth"],
  ["sentara_health_plans", "Sentara Health Plans"],
  ["sharp", "Sharp"],
  ["sun_life", "Sun Life"],
  ["trustmark", "Trustmark"],
  ["tufts", "Tufts Health Plan"],
  ["united_healthcare", "United Healthcare"],
  ["upmc", "UPMC"],
  ["upmc", "UPMC Blue Cross Blue Shield"],
  ["vsp", "VSP"],
  ["other", "Other"],
];

export const SUPPORTED_CARRIER_HASH = Object.fromEntries(SUPPORTED_CARRIERS);

export const CONTACT_SUPPORT_LINK = "https://support.simplyinsured.com/s/contactsupport";

export const FORM_NAME = "brokerOfRecord";
